angular.module("showcaseApp")
    .directive("bottomUpSelect", function($window) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/bottom-up-mobile-select/bottom-up-select.html',
            scope: {
                options: '=?',
                findOptionsApi: '&?',
                loadOptionsErrorMessage: '@?',
                valueMap: '<?',
                totalItems: '=?',
                pageIndex: '=?',
                readOnly: '<?',
                model: '=',
                onClose: '&?',
                buttonText: '@?',
                selectedText: '@?',
                onConfirm: '=',
                fullscreen: '<',
                hasSearch: '<',
                inputType: '@?',
                selectAllOption: '<?',
                isFemaleNoun: '<?'
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: function($scope, $translate, systemConstants, toastr, $timeout) {
                var vm = this;

                var inputTypes = ['button', 'field'];
                var defaultInputType = 'button';

                var defaultValueMap = {'id': 'id', 'label': 'label', 'value': 'value'};
                var selectedDisplayLabelCount = 1;
                var selectScrollPageSize = 10;

                vm.searchText = '';
                vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
                vm.buttonClass = vm.buttonClass || 'btn-select-size';
                vm.modalVisible = false;
                vm.initialModel = getDefaultModel();
                vm.loading = false;
                vm.totalItems = vm.totalItems || 0;
                vm.pageIndex = vm.pageIndex || 0;
                var paginationOptions = {
                    page: vm.pageIndex,
                    size: selectScrollPageSize
                };

                vm.$onInit = function () {
                    vm.inputType = vm.inputType && inputTypes.includes(vm.inputType) ? vm.inputType : defaultInputType;
                    vm.options = vm.options || [];
                    vm.findOptionsApi = findBindingBaseFunction(vm.findOptionsApi);
                    vm.isOptionsFromApi = angular.isFunction(vm.findOptionsApi);
                    vm.loadOptionsErrorMessage = vm.loadOptionsErrorMessage || undefined;
                    vm.valueMap = vm.valueMap || defaultValueMap;
                    vm.optionIdKey = Object.keys(vm.valueMap).find(function (key) {
                        return key === 'id';
                    });
                    vm.optionLabelKey = Object.keys(vm.valueMap).find(function (key) {
                        return key === 'label';
                    });
                    vm.optionValueKey = Object.keys(vm.valueMap).find(function (key) {
                        return key === 'value';
                    });
                    vm.readOnly = vm.readOnly || false;

                    vm.selectAllOption = vm.selectAllOption || false;
                    vm.isFemaleNoun = vm.isFemaleNoun || false;

                    if (vm.isOptionsFromApi) {
                        if (!vm.options || vm.options.length === 0) {
                            fetchFilterOptionsFromCallback();
                        }

                        if (vm.hasSearch) {
                            $scope.$watch('vm.searchText', function (newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    paginationOptions.page = 0;
                                    fetchFilterOptionsFromCallback();
                                }
                            });
                        }
                    } else if (angular.isArray(vm.options) && vm.options.length > 0) {
                        vm.options = formatOptionsDict(vm.options);
                    }
                };

                vm.getAllSelectedText = function () {
                    return vm.isFemaleNoun ? 'global.form.all-female' : 'global.form.all'
                }

                vm.isIndeterminate = function () {
                    if(vm.selectAllOption && vm.isOptionsFromApi) {
                        var hasExceptions = vm.model.all && vm.model.except && vm.model.except.length > 0;
                        var hasSomeButNotAllSelected =
                            !vm.model.all && vm.model.only && vm.model.only.length > 0 &&
                            vm.model.only.length < vm.totalItems
                        return hasExceptions || hasSomeButNotAllSelected;
                    } else {
                        return angular.isArray(vm.model) && vm.model.length > 0 &&
                            vm.model.length !== vm.options.length;
                    }
                };

                vm.toggleModal = function() {
                    if (!vm.modalVisible) {
                        vm.initialModel = angular.copy(vm.model);
                    }
                    vm.modalVisible = !vm.modalVisible;
                };

                vm.closeModal = function () {
                    vm.model = angular.copy(vm.initialModel);
                    vm.modalVisible = false;
                };

                vm.confirmSelection = function () {
                    if (vm.onClose) {
                        vm.onClose();
                    }
                    vm.initialModel = angular.copy(vm.model);
                    vm.closeModal();
                };


                vm.updateSelection = function() {
                    vm.model = vm.options.filter(function(item) {
                        return item.checked;
                    });
                };

                vm.isAllSelected = function () {
                    if (vm.model && vm.selectAllOption && vm.isOptionsFromApi) {
                        return vm.model.all && (!vm.model.except || vm.model.except.length === 0);
                    } else {
                        return angular.isArray(vm.model) && angular.isArray(vm.options) && vm.model.length === vm.options.length;
                    }
                };

                vm.toggleSelectAll = function () {
                    if (vm.selectAllOption && vm.isOptionsFromApi) {
                        var allSelected = vm.isAllSelected();
                        vm.model = getSelectAllPaginatedModel();
                        vm.model.all = !allSelected;
                    } else {
                        if (vm.isAllSelected()) {
                            vm.model = [];
                        } else {
                            vm.model = angular.copy(vm.options);
                        }
                    }
                };

                vm.hasSelection = function () {
                    return vm.options.some(function (item) {
                        return item.checked;
                    });
                };

                vm.isSelected = function (option) {
                    if (vm.selectAllOption && vm.isOptionsFromApi) {
                        if (vm.model.all) {
                            return !vm.model.except.some(function (item) {
                                if (vm.optionValueKey) {
                                    return item === option[vm.optionValueKey];
                                } else if (vm.optionIdKey) {
                                    return item === option[vm.optionIdKey];
                                } else {
                                    return item === option;
                                }
                            });
                        } else {
                            return vm.model.only.some(function (item) {
                                if (vm.optionValueKey) {
                                    return item === option[vm.optionValueKey];
                                } else if (vm.optionIdKey) {
                                    return item === option[vm.optionIdKey];
                                } else {
                                    return item === option;
                                }
                            });
                        }
                    } else {
                        return angular.isArray(vm.model) && vm.model.some(function (item) {
                            return item.id === option.id;
                        });
                    }
                };

                vm.toggleSelection = function (option) {
                    if (vm.selectAllOption && vm.isOptionsFromApi) {
                        if (!angular.isObject(vm.model)) {
                            vm.model = getSelectAllPaginatedModel();
                        }

                        if (vm.model.all) {
                            var exceptIndex = vm.model.except.findIndex(function (item) {
                                if (vm.optionValueKey) {
                                    return item === option[vm.optionValueKey];
                                } else if (vm.optionIdKey) {
                                    return item === option[vm.optionIdKey];
                                } else {
                                    return item === option;
                                }
                            });

                            if (exceptIndex > -1) {
                                vm.model.except.splice(exceptIndex, 1);
                            } else {
                                if (vm.model.except.length === vm.totalItems - 1) {
                                    vm.model.except = [];
                                    vm.model.all = false;
                                } else if (vm.optionValueKey) {
                                    vm.model.except.push(option[vm.optionValueKey]);
                                } else if (vm.optionIdKey) {
                                    vm.model.except.push(option[vm.optionIdKey]);
                                } else {
                                    vm.model.except.push(option);
                                }
                            }
                        } else {
                            var selectedIndex = vm.model.only.findIndex(function (item) {
                                if (item.id) {
                                    return item.id === option.id;
                                } else {
                                    return item === option.id;
                                }
                            });

                            if (selectedIndex > -1) {
                                vm.model.only.splice(selectedIndex, 1);
                            } else if (vm.optionValueKey) {
                                vm.model.only.push(option[vm.optionValueKey]);
                            } else if (vm.optionIdKey) {
                                vm.model.only.push(option[vm.optionIdKey]);
                            } else {
                                vm.model.only.push(option);
                            }
                        }
                    } else {
                        if (!angular.isArray(vm.model)) {
                            vm.model = [];
                        }

                        var index = vm.model.findIndex(function (item) {
                            return item.id === option.id;
                        });

                        if (index > -1) {
                            vm.model.splice(index, 1);
                        } else {
                            vm.model.push(option);
                        }
                    }
                };

                vm.getHeaderTitle = function () {
                    var match = vm.buttonText && vm.buttonText.match(/^\S+/);
                    return match ? match[0] : '';
                }

                vm.clearSelection = function ($event) {
                    $event.stopPropagation();
                    vm.model = getDefaultModel();

                    if (typeof vm.onConfirm === 'function') {
                        $timeout(function () {
                            vm.onConfirm();
                        }, 0);
                    }
                };

                vm.translateTruncated = function (text, size) {
                    return truncateText($translate.instant(text), size);
                }

                vm.fetchNextPage = function () {
                    if (!vm.loading && vm.isOptionsFromApi) {
                        if ((vm.options.length < vm.totalItems)) {
                            vm.pageIndex++;
                            paginationOptions.page = vm.pageIndex;
                            fetchFilterOptionsFromCallback();
                        }
                    }
                }

                vm.getSelectedText = function () {
                    if (vm.selectAllOption && vm.isAllSelected()) {
                        return $translate.instant(vm.getAllSelectedText());
                    }

                    if (vm.model && vm.selectAllOption && vm.isOptionsFromApi) {
                        if (vm.model.firstSelected) {
                            if (vm.optionLabelKey) {
                                var dtoLabelKey = vm.valueMap[vm.optionLabelKey];
                                return vm.model.firstSelected[dtoLabelKey] ?
                                    vm.model.firstSelected[dtoLabelKey] : '';
                            } else {
                                return '';
                            }
                        } else if (vm.model.only && vm.model.only.length > 0) {
                            var firstOnlyOption = vm.options.find(function (option) {
                                if (vm.optionValueKey) {
                                    return option[vm.optionValueKey] === vm.model.only[0];
                                } else if (vm.optionIdKey) {
                                    return option[vm.optionIdKey] === vm.model.only[0];
                                } else {
                                    return option === vm.model.only[0];
                                }
                            });
                            if (firstOnlyOption) {
                                return firstOnlyOption[vm.optionLabelKey] ?
                                    firstOnlyOption[vm.optionLabelKey] : firstOnlyOption;
                            } else {
                                return '';
                            }
                        } else if (vm.model.all) {
                            if (vm.model.except && vm.model.except.length > 0) {
                                var firstSelectedOption = vm.options.find(function (option) {
                                    if (vm.optionValueKey) {
                                        return vm.model.except.indexOf(option[vm.optionValueKey]) === -1;
                                    } else if (vm.optionIdKey) {
                                        return vm.model.except.indexOf(option[vm.optionIdKey]) === -1;
                                    } else {
                                        return !vm.model.except.some(function (exceptItem) {
                                            return option === exceptItem;
                                        });
                                    }
                                });
                                return firstSelectedOption && firstSelectedOption[vm.optionLabelKey] ?
                                    firstSelectedOption[vm.optionLabelKey] : '';
                            } else {
                                return vm.options && vm.options.length > 0 ?
                                    vm.options[0][vm.optionLabelKey] || vm.options[0] : '';
                            }
                        }
                    } else if (angular.isArray(vm.model) && vm.model.length > 0) {
                        return vm.model[0] && vm.model[0][vm.optionLabelKey] ?
                            vm.model[0][vm.optionLabelKey] || vm.model[0] : '';
                    } else {
                        return '';
                    }
                };

                vm.getSelectedPlusCount = function () {
                    var selectedCount;
                    if (vm.selectAllOption && vm.isOptionsFromApi) {
                        if (vm.model.all) {
                            selectedCount = vm.totalItems - vm.model.except.length;
                        } else {
                            selectedCount = vm.model.only.length;
                        }
                    } else {
                        selectedCount = vm.model.length;
                    }

                    return selectedCount > selectedDisplayLabelCount ?
                        ' ' + $translate.instant('global.form.selected-plus',
                            { count: selectedCount - selectedDisplayLabelCount }) : '';
                }

                vm.hasAnySelected = function () {
                    var hasModel = !!vm.model;
                    var hasSelectAllPaginated = vm.isOptionsFromApi && vm.selectAllOption;
                    var hasAnySelected = false;
                    if (hasModel) {
                        if (hasSelectAllPaginated) {
                            hasAnySelected = (vm.model.all || (vm.model.only && vm.model.only.length > 0));
                        } else {
                            hasAnySelected = angular.isArray(vm.model) && vm.model.length > 0;
                        }
                    }
                    return hasAnySelected;
                }

                angular.element($window).on('resize', function() {
                    $scope.$apply(function() {
                        vm.isMobile = $window.innerWidth < 768;
                        if (!vm.isMobile) {
                            vm.closeModal();
                        }
                    });
                });

                $scope.$on('$destroy', function() {
                    angular.element($window).off('resize');
                });

                function fetchFilterOptionsFromCallback() {
                    vm.loading = true;
                    if (angular.isFunction(vm.findOptionsApi)) {
                        vm.findOptionsApi(
                            paginationOptions,
                            vm.searchText,
                            onSuccessFetchFilterOptionsFromCallback,
                            onErrorFetchFilterOptionsFromCallback
                        );
                    } else {
                        vm.loading = false;
                    }
                }

                function onSuccessFetchFilterOptionsFromCallback(response) {
                    if (response && response.data) {
                        var responsePage;
                        if (angular.isArray(response.data.content)) { // Response is Page
                            responsePage = response.data.content;
                            vm.totalItems = response.data.totalElements || 0;
                        } else if (angular.isArray(response.data)) { // Response is List
                            responsePage = response.data;
                            vm.totalItems = response.headers['x-total-count'] || 0;
                        }
                        if (responsePage !== undefined) {
                            if (paginationOptions.page === 0) {
                                if (response.data.content) {
                                    vm.options = response.data.content.map(mapResponseItemToOption);
                                } else {
                                    vm.options = response.data.map(mapResponseItemToOption);
                                }
                            } else {
                                var newOptions = response.data.content ? response.data.content.map(mapResponseItemToOption) : response.data.map(mapResponseItemToOption);
                                vm.options = vm.options.concat(newOptions);
                            }
                        }
                    } else {
                        vm.options = [];
                    }

                    vm.loading = false;

                    function mapResponseItemToOption(item) {
                        var mappedItem = {};
                        var selectModelKeys = vm.valueMap ? Object.keys(vm.valueMap) : [];
                        selectModelKeys.forEach(function (selectModelKey) {
                            mapItemProperty(mappedItem, selectModelKey, item, vm.valueMap[selectModelKey]);
                        });
                        return mappedItem;
                    }

                    function mapItemProperty(currentMappedProperty, currentKey, item, itemPropertyKey) {
                        var keySeparatorIndex = currentKey.indexOf('.');
                        var hasSubKey = keySeparatorIndex !== -1;
                        if (!hasSubKey) {
                            currentMappedProperty[currentKey] = fetchProperty(item, itemPropertyKey);
                        } else {
                            var currentPropertyKey = currentKey.substring(0, keySeparatorIndex);
                            var subKey = currentKey.substring(keySeparatorIndex + 1);
                            if (!currentMappedProperty.hasOwnProperty(currentPropertyKey)) {
                                currentMappedProperty[currentPropertyKey] = {};
                            }
                            mapItemProperty(currentMappedProperty[currentPropertyKey], subKey, item, itemPropertyKey);
                        }
                    }

                    function fetchProperty(item, propertyKey) {
                        var keySeparatorIndex = propertyKey.indexOf('.');
                        var hasSubKey = keySeparatorIndex !== -1;
                        if (!hasSubKey) {
                            return item.hasOwnProperty(propertyKey) ? item[propertyKey] : undefined;
                        } else {
                            var currentPropertyKey = propertyKey.substring(0, keySeparatorIndex);
                            var subKey = propertyKey.substring(keySeparatorIndex + 1);
                            if (item.hasOwnProperty(currentPropertyKey)) {
                                return fetchProperty(item[currentPropertyKey], subKey);
                            } else {
                                return undefined;
                            }
                        }
                    }
                }

                function onErrorFetchFilterOptionsFromCallback() {
                    if (vm.loadOptionsErrorMessage) {
                        toastr.error(vm.loadOptionsErrorMessage);
                    }
                    vm.loading = false;
                }

                function getDefaultModel() {
                    if (vm.selectAllOption && vm.isOptionsFromApi) {
                        return getSelectAllPaginatedModel();
                    } else {
                        return [];
                    }
                }

                function formatOptionsDict(optionsDict) {
                    return formatSelectOptions(optionsDict);
                }
            }
        };
    });
